import { LandingMediaDropbox } from './MediaDropBox';
import { FieldTitle } from './RedStarTitle';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import {
  useFormContext,
  Controller,
  UseFormRegisterReturn,
} from 'react-hook-form';
import { TextField } from '@client/new/components/basic';
import { BulletsInput } from './BulletsInput';
import { SelectImageSideInput } from './SelectImageSide';
import { TwoColumns } from './layouts';

type Props = {
  imageUpload: (file: File) => Promise<string>;
  register: (s: string) => UseFormRegisterReturn;
  index: number;
};
export function FeaturedBenefit({ imageUpload, register: r, index }: Props) {
  const { control } = useFormContext();

  const firstCol = (
    <>
      <div>
        <FieldTitle title={'Headline text'} />
        <div className="max-w-[680px]">
          <TextField
            {...r(`title`)}
            className="mb-[5px] w-full"
            inputProps={{
              placeholder: 'Headline text',
              maxLength: 60,
            }}
          />
        </div>
      </div>

      <div>
        <BulletsInput name={`sections.${index}.bullets`} />
      </div>
    </>
  );
  const secondCol = (
    <>
      <section>
        <div>
          <Controller
            name={`sections.${index}.coverImage`}
            control={control}
            render={({
              field: { value, onChange, ref },
              fieldState: { error },
            }) => (
              <LandingMediaDropbox
                inputRef={ref}
                width="200px"
                height="408px"
                upload={imageUpload}
                label="Image"
                validationText=""
                value={value}
                onChange={onChange}
                type="image"
                icon={faImage as any}
                errorMsg={error?.message}
              >
                <ul className="text-black list-none text-center text-h12">
                  <li>Iphone resolution </li>
                </ul>
              </LandingMediaDropbox>
            )}
          />
        </div>
        <div className="mt-4">
          <SelectImageSideInput index={index} />
        </div>
      </section>
    </>
  );

  return <TwoColumns first={firstCol} second={secondCol} />;
}
